import React from 'react'

import OfficialBadge from '@components/music/OfficialBadge'
import Title from '@models/Title'
import TitleProvider from '@providers/TitleProvider'

import CloseButton from '../CloseButton'
import Controls from './Controls'
import Details from './Details'
import SellerInfo from './SellerInfo'
import Social from './Social'
import AuthorizedPerformers from './purchased-product/AuthorizedPerformers'

interface Props {
  title: Title | null
  onClose: (e: React.MouseEvent) => void
}

const TitleDetails: React.FC<Props> = ({ title, onClose }) => {
  if (!title) return null

  return (
    <TitleProvider title={title}>
      <section className="h-full bg-white dark:bg-black-bg2 border-l border-l-gray dark:border-l-gray-border-dm p-5 overflow-y-auto [scrollbar-gutter:stable]">
        <div className="flex flex-row items-start">
          <h3 className="text-h3 font-semibold min-h-[1.5rem] flex-1 mr-1 mt-2">
            <span className="mr-1">{title.title}</span>
            {!title.metadata.usergen && <OfficialBadge />}
          </h3>
          <CloseButton id="title-details-close-btn" onClick={onClose} />
        </div>
        <Controls />
        <AuthorizedPerformers />
        <Details />
        <Social />
        <SellerInfo />
      </section>
    </TitleProvider>
  )
}

export default TitleDetails
